// @flow
import React from 'react'
import type { Field } from 'lib/types'
import FieldWrapper from './FieldWrapper'
import styles from './styles'

const makeOpt = (key, val) => {
  const opts = {
    key,
    value: key,
  }

  return <option {...opts}>{val}</option>
}

const options = (values, placeholderText = 'Select an option') => {
  let data = []
  if (Array.isArray(values)) {
    data = values.map((val) => makeOpt(val, val))
    data.unshift(
      <option value="" key="-1">
        {placeholderText}
      </option>,
    )
  } else {
    data = Object.keys(values).map((key) => makeOpt(key, values[key]))
    data.unshift(
      <option value="" key="-1">
        {placeholderText}
      </option>,
    )
  }

  return data
}

const markup = (field: Field) => {
  const { autoFocus, input, options: opts, placeholderText, required, disabled } = field
  if (field.newValue) {
    input.value = field.newValue
  }

  const selectClassName = disabled ? `${styles.select} ${styles.selectDisabled}` : styles.select

  return (
    <select {...input} autoFocus={autoFocus} className={selectClassName} required={required} disabled={disabled}>
      {options(opts, placeholderText)}
    </select>
  )
}

const renderSelectField = (field: Field) => {
  const {
    button,
    children,
    disabled,
    input,
    label,
    meta,
    meta: { asyncValidating },
    placeholder,
    required,
    type,
  } = field

  const props = {
    asyncValidating,
    button,
    disabled,
    innerButton: children,
    label: label || null,
    meta,
    name: input.name,
    placeholder,
    required,
    type,
  }

  return <FieldWrapper {...props}>{markup(field)}</FieldWrapper>
}

export default renderSelectField
